import { types } from 'mobx-state-tree';

export const BarsRoleUser = types.model({
  id: types.integer,
  role_user_id: types.integer,
  bar_id: types.integer,
});
